import { equalsIgnoreCase } from "../utilities";
import {
  DryFormulationSpellings,
  DryFormulationUnitOfMeasure,
  LiquidFormulationSpellings,
  LiquidFormulationUnitOfMeasure,
} from "./UnitOfMeasures";

export enum RewardsUom {
  Acres = 'ac',
  Bags = 'bags',
  Bushels = 'bu',
  Dollars = '$',
  Each = 'each',
  Gallons = 'gal',
  Kilograms = 'kg',
  Litres = 'l',
  Tons = 'ton',
}

export const RewardsUomAcceptedSpellings: Record<RewardsUom, string[]> = {
  [RewardsUom.Acres]: ['ac', 'acre', 'acres'],
  [RewardsUom.Bags]: ['bg', 'bag', 'bags'],
  [RewardsUom.Bushels]: ['bu', 'bushel', 'bushels'],
  [RewardsUom.Dollars]: ['$', 'dollar', 'dollars'],
  [RewardsUom.Each]: ['ea', 'each'],
  [RewardsUom.Gallons]: LiquidFormulationSpellings[LiquidFormulationUnitOfMeasure.GALLON],
  [RewardsUom.Kilograms]: DryFormulationSpellings[DryFormulationUnitOfMeasure.KILOGRAM],
  [RewardsUom.Litres]: LiquidFormulationSpellings[LiquidFormulationUnitOfMeasure.LITRE],
  [RewardsUom.Tons]: DryFormulationSpellings[DryFormulationUnitOfMeasure.TON],
};

export const RewardsUomPluralization: Record<RewardsUom, { singular: string, plural: string }> = {
  [RewardsUom.Acres]: { singular: 'acre', plural: 'acres' },
  [RewardsUom.Bags]: { singular: 'bag', plural: 'bags' },
  [RewardsUom.Bushels]: { singular: 'bushel', plural: 'bushels' },
  [RewardsUom.Dollars]: { singular: '$', plural: '$' },
  [RewardsUom.Each]: { singular: 'each', plural: 'each' },
  [RewardsUom.Gallons]: { singular: 'gallon', plural: 'gallons' },
  [RewardsUom.Kilograms]: { singular: 'kilogram', plural: 'kilograms' },
  [RewardsUom.Litres]: { singular: 'litre', plural: 'litres' },
  [RewardsUom.Tons]: { singular: 'ton', plural: 'tons' },
};

export const formatRewardsUoM = (quantity: number, unit: RewardsUom): string => {
  const { singular, plural } = RewardsUomPluralization[unit];
  return quantity === 1 ? singular : plural;
};

export const parseRewardsUom = (input: string | null): RewardsUom | null => {
  if (input === null) {
    return null;
  }
  const uoms = Object.values(RewardsUom);
  for (const uom of uoms) {
    const options = RewardsUomAcceptedSpellings[uom];
    for (const option of options) {
      if (equalsIgnoreCase(option, input)) {
        return uom;
      }
    }
  }
  return null;
};